{
    "WjWIspkiEnxF_xOR20nB8": {
        "key": "WjWIspkiEnxF_xOR20nB8",
        "position": {
            "x": 14,
            "y": 25,
            "z": 1
        },
        "tag": "spawn"
    },
    "9RmtRQX2Q82pOxnkQp4qD": {
        "key": "9RmtRQX2Q82pOxnkQp4qD",
        "position": {
            "x": 15,
            "y": 25,
            "z": 1
        },
        "tag": "spawn"
    },
    "OYDw6LC5MyKjslXth-dmA": {
        "key": "OYDw6LC5MyKjslXth-dmA",
        "position": {
            "x": 16,
            "y": 25,
            "z": 1
        },
        "tag": "spawn"
    },
    "hUWMTYYXDJB2zH_YrRlaU": {
        "key": "hUWMTYYXDJB2zH_YrRlaU",
        "position": {
            "x": 13,
            "y": 25,
            "z": 1
        },
        "tag": "spawn"
    },
    "NnR79OiiWg_9jSI2a0ZHV": {
        "key": "NnR79OiiWg_9jSI2a0ZHV",
        "position": {
            "x": 14,
            "y": 20,
            "z": 1
        },
        "tag": "spawn"
    },
    "4kYEJK8OM_TvhvrUOFnLg": {
        "key": "4kYEJK8OM_TvhvrUOFnLg",
        "position": {
            "x": 15,
            "y": 20,
            "z": 1
        },
        "tag": "spawn"
    },
    "Wj7NbSKxp6Xl8ZQCCRQLY": {
        "key": "Wj7NbSKxp6Xl8ZQCCRQLY",
        "position": {
            "x": 16,
            "y": 20,
            "z": 1
        },
        "tag": "spawn"
    },
    "lgniPEbF2vxG1CA_2DdV6": {
        "key": "lgniPEbF2vxG1CA_2DdV6",
        "position": {
            "x": 13,
            "y": 20,
            "z": 1
        },
        "tag": "spawn"
    },
    "np3-XRjwxqSY2R4ULuJfz": {
        "key": "np3-XRjwxqSY2R4ULuJfz",
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "tag": "spawn"
    },
    "5weUgbdO1d8LIdWwrWFPM": {
        "key": "5weUgbdO1d8LIdWwrWFPM",
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "tag": "spawn"
    },
    "txcHrMogv-V7vTusOTp35": {
        "key": "txcHrMogv-V7vTusOTp35",
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "tag": "spawn"
    },
    "hwg6ocwSF05yHjBsuZw6s": {
        "key": "hwg6ocwSF05yHjBsuZw6s",
        "position": {
            "x": 13,
            "y": 15,
            "z": 1
        },
        "tag": "spawn"
    },
    "DzokaHVmO3I9pHIBtUx5y": {
        "key": "DzokaHVmO3I9pHIBtUx5y",
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "tag": "spawn"
    },
    "D0EVS2fKGylAnxNN8F6t8": {
        "key": "D0EVS2fKGylAnxNN8F6t8",
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "tag": "spawn"
    },
    "CP7EqUl_OKW2SFB8Pdp3Q": {
        "key": "CP7EqUl_OKW2SFB8Pdp3Q",
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "tag": "spawn"
    },
    "m6klvJImc6u8DmhxPWNJS": {
        "key": "m6klvJImc6u8DmhxPWNJS",
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "tag": "spawn"
    },
    "vALcS1m-DoMRe0MGan11w": {
        "key": "vALcS1m-DoMRe0MGan11w",
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "tag": "monster2"
    },
    "A8jweGaA7_WwhyDFYAW4U": {
        "key": "A8jweGaA7_WwhyDFYAW4U",
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "tag": "monster3"
    },
    "Cdqv-0YFSiDSmWYilExei": {
        "key": "Cdqv-0YFSiDSmWYilExei",
        "position": {
            "x": 15,
            "y": 7,
            "z": 1
        },
        "tag": "monster4"
    }
}